/**
 * Firestore collection name constants.
 *
 * Never use raw string literals for collection names in app code.
 * Import these so renaming a collection is a single-file change.
 */

// ── Top-level collections ─────────────────────────────────────────────────────
export const COL = {
  // People & auth
  CLIENTS: 'clients',
  USERS: 'users',
  ROLES: 'roles',

  // Memberships & progression
  MEMBERSHIPS: 'memberships',
  MEMBERSHIP_PLANS: 'membership_plans',
  ACHIEVEMENTS: 'achievements',
  ACHIEVEMENT_PROGRESS: 'achievement_progress',
  BATTLEPASS_SEASONS: 'battlepass_seasons',
  BATTLEPASS_PROGRESS: 'battlepass_progress',
  CLIENT_ACTIVITY_EVENTS: 'client_activity_events',

  // Workstations & sessions
  WORKSTATIONS: 'workstations',
  SESSIONS: 'sessions',
  GAMES: 'games',
  APPS: 'apps',
  FLEET_CONFIG: 'fleet_config',

  // Restaurant & retail
  MENU_ITEMS: 'menu_items',
  MENU_CATEGORIES: 'menu_categories',
  COMBOS: 'combos',
  RETAIL_PRODUCTS: 'retail_products',
  RETAIL_CATEGORIES: 'retail_categories',

  // Orders & fulfillment
  ORDERS: 'orders',
  PAGER_CODES: 'pager_codes',

  // POS
  POS_CARTS: 'pos_carts',
  CASH_SHIFTS: 'cash_shifts',
  POS_DEVICE_PAIRINGS: 'pos_device_pairings',
  CREDIT_PROMOS: 'credit_promos',
  GIFT_CARDS: 'gift_cards',
  COUPONS: 'coupons',

  // IoT
  IOT_DEVICES: 'iot_devices',

  // Reservations
  RESERVATIONS: 'reservations',

  // Config & ops
  PLATFORM_CONFIG: 'platform_config',
  AUDIT_LOG: 'audit_log',

  // Odoo integration
  ODOO_SYNC_STATE: 'odoo_sync_state',

  // Analytics & reporting
  ANALYTICS_ROLLUPS: 'analytics_rollups',
  REPORT_SENDS: 'report_sends',
  ODOO_FINANCIAL_SNAPSHOTS: 'odoo_financial_snapshots',
};

// ── Sub-collections ───────────────────────────────────────────────────────────
export const SUBCOL = {
  /** workstations/{id}/queue/{cmdId} */
  WORKSTATION_QUEUE: 'queue',
};

// ── Singleton document IDs ────────────────────────────────────────────────────
export const DOC = {
  /** platform_config/main — the single global config document. */
  PLATFORM_CONFIG_MAIN: 'main',
  /** fleet_config/main — the single fleet defaults document. */
  FLEET_CONFIG_MAIN: 'main',
};
